import React from 'react';
import { Table } from 'reactstrap';
import { sampleDetailBreakdown } from '../../mockData';

const BerakhlakWeightingTable = ({
  berakhlakWeightings = [],
  berakhlakSummary,
  totalMapping = 13,
}) => {
  const rows =
    berakhlakWeightings.length > 0
      ? berakhlakWeightings
      : sampleDetailBreakdown.berakhlakWeightings;

  const summary =
    berakhlakSummary || sampleDetailBreakdown.berakhlakSummary;

  const renderPredikatBadge = (predikat, predikatId) => {
    if (!predikat || predikat === '-') {
      return <span>-</span>;
    }
    const badgeClass = predikatId || predikat.toLowerCase().replace(/\s+/g, '-');
    return <span className={`p360-badge ${badgeClass}`}>{predikat}</span>;
  };

  return (
    <div className="p360-berakhlak-container mb-4">
      {/* Section Header */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <div className="p360-berakhlak-title">
          {/* <i className="uil uil-book-open text-success" style={{ fontSize: '1.25rem' }}></i> */}
          <span>Rincian &amp; Rekapitulasi Pembobotan Core Values BerAKHLAK</span>
        </div>
        <div className="p360-evaluator-mapping-info">
          <i className="uil uil-info-circle text-muted"></i>
          <span>Total Mapping: {totalMapping} Penilai</span>
        </div>
      </div>

      {/* Table Container */}
      <div className="p360-table-container">
        <Table responsive className="p360-table p360-berakhlak-table align-middle mb-0">
          <thead>
            <tr>
              <th style={{ minWidth: '280px' }}>Core Value / Kompetensi BerAKHLAK</th>
              <th className="text-center" style={{ minWidth: '150px' }}>Rata-rata Atasan</th>
              <th className="text-center" style={{ minWidth: '150px' }}>Rata-rata Sejawat</th>
              <th className="text-center" style={{ minWidth: '160px' }}>Hasil (Terbobot)</th>
              <th className="text-center" style={{ minWidth: '150px' }}>Predikat</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                <td>
                  <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.875rem' }}>
                    {row.coreValue}
                  </div>
                  <div className="text-muted small" style={{ fontSize: '0.8rem' }}>
                    {row.deskripsi}
                  </div>
                </td>
                <td className="text-center" style={{ fontWeight: 500 }}>
                  {row.rataRataAtasan}
                </td>
                <td className="text-center" style={{ fontWeight: 500 }}>
                  {row.rataRataSejawat}
                </td>
                <td className="text-center" style={{ fontWeight: 600 }}>
                  {row.hasilTerbobot}
                </td>
                <td className="text-center">
                  {renderPredikatBadge(row.predikat, row.predikatId)}
                </td>
              </tr>
            ))}

            {/* Summary Row */}
            {summary && (
              <tr className="p360-berakhlak-summary-row">
                <td style={{ fontWeight: 600, color: '#334155' }}>
                  Rata-Rata BerAKHLAK Per-Kelompok Penilai:
                </td>
                <td className="text-center" style={{ fontWeight: 600 }}>
                  {summary.rataRataAtasan}
                </td>
                <td className="text-center" style={{ fontWeight: 600 }}>
                  {summary.rataRataSejawat}
                </td>
                <td></td>
                <td className="text-center text-muted fst-italic small">
                  {summary.keterangan}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Final Nilai Bar */}
      {summary && (
        <div className="p360-berakhlak-footer-bar">
          <span className="fw-bold" style={{ fontSize: '0.95rem', color: '#1e293b' }}>
            NILAI FINAL BERAKHLAK:
          </span>
          <div className="p360-group-summary-value-box" style={{ fontSize: '1rem', padding: '0.35rem 1.35rem' }}>
            {summary.nilai_final}
          </div>
          {renderPredikatBadge(summary.predikat_final, summary.predikat_final_id)}
        </div>
      )}
    </div>
  );
};

export default BerakhlakWeightingTable;
